import styled from "styled-components";
import Chip from "../Chip";
import Table from "../DataTable";
import ActionImageButton from "../DataTable/ActionImageButton";
import ListWithPagination from "../ListsWithPagination";
import LinkPriceListingModal from "./LinkPriceListingModal";

interface Props {
  data: {
    _id: string;
    isActive: boolean;
    name: string;
    category: string;
    price: string | number;
    bgColor: string;
    productId: string;
  }[];
  onEdit: (id: string) => void;
  isTableDataLoading: boolean;
  outlet: string;
  durationObj: any;
}

const ParksProductTable = ({
  data,
  onEdit,
  isTableDataLoading,
  outlet,
  durationObj,
}: Props) => {
  const aquaColumns = [
    {
      path: "productId",
      label: "ID",
    },
    {
      path: "category",
      label: "Category",
    },
    {
      path: "name",
      label: "Product Name",
      content: (data: any) => <div style={{ width: "270px" }}>{data.name}</div>,
    },
    {
      path: "subtitle",
      label: "Subtitle",
      content: (data: any) => (
        <div style={{ width: "270px" }}>{data.subtitle}</div>
      ),
    },
    {
      path: "inventory",
      label: "Inventory",
    },
    {
      key: "isActive",
      label: "Status",
      content: (parkProduct: any) => (
        <Chip
          label={parkProduct.isActive ? "Active" : "Inactive"}
          variant={parkProduct.isActive ? "success" : "error"}
        />
      ),
    },
    {
      label: "Action",
      key: "edit",
      content: (parkProduct: {
        _id: string;
        isActive: boolean;
        name: string;
        category: string;
        price: string | number;
        bgColor: string;
      }) => (
        <ActionImageButton
          onClick={() => onEdit(parkProduct._id)}
          iconPath={require("../../assets/images/edit-icon.png")}
          label="Edit Category"
        />
      ),
    },
    // [...durationObj],
  ];

  const columns = [
    {
      path: "productId",
      label: "ID",
    },
    {
      path: "name",
      label: "Product Name",
      content: (data: any) => <div style={{ width: "270px" }}>{data.name}</div>,
    },
    {
      path: "description",
      label: "Product Info",
      content: (data: any) => (
        <div style={{ width: "270px" }}>{data.description}</div>
      ),
    },
    {
      path: "price",
      label: "Price",
      content: (data: { price: { [any: string]: string } }) => (
        <LinkPriceListingModal linkText="View Price" price={data.price} />
      ),
    },
    {
      path: "bgColor",
      label: "Card Color Code",
    },
    {
      key: "isActive",
      label: "Status",
      content: (parkProduct: {
        _id: string;
        isActive: boolean;
        name: string;
        category: string;
        price: string | number;
        bgColor: string;
      }) => (
        <Chip
          label={parkProduct.isActive ? "Active" : "Inactive"}
          variant={parkProduct.isActive ? "success" : "error"}
        />
      ),
    },
    {
      label: "Action",
      key: "edit",
      content: (parkProduct: {
        _id: string;
        isActive: boolean;
        name: string;
        category: string;
        price: string | number;
        bgColor: string;
      }) => (
        <ActionImageButton
          onClick={() => onEdit(parkProduct._id)}
          iconPath={require("../../assets/images/edit-icon.png")}
          label="Edit Category"
        />
      ),
    },
  ];

  let aquaZoneColumns;
  if (outlet === "aqua_zone") {
    let firstIndices = [...aquaColumns.slice(0, 5)];
    let lastIndices = [...aquaColumns.slice(5)];
    aquaZoneColumns = [...firstIndices, ...durationObj, ...lastIndices];
  }else{
    aquaZoneColumns = [...columns]
  }

  return (
    <>
      <TableWrapper>
        <Table
          columns={aquaZoneColumns}
          data={data}
        />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          columns={aquaZoneColumns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={"Product Details"}
          onRowClick={undefined}
          hidePagination={true}
          currentPage={0}
          totalData={0}
          rowsPerPage={0}
          onPageChange={function (page: number): void {
            throw new Error("Function not implemented.");
          }}
        />
      </ListWrapper>
    </>
  );
};

const TableWrapper = styled.div`
  display: block;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

export default ParksProductTable;
